module.exports = __webpack_public_path__ + "static/media/place.a1701ba3.svg";


//////////////////
// WEBPACK FOOTER
// ./src/Home/img/place.svg
// module id = 237
// module chunks = 8